import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core'
import { NgForm } from '@angular/forms'
import { Situacao } from '../../pkw-data/collect/estabelecimento/situacao.enum'
import { OperadoraDeMaquina } from '../../pkw-data/collect/operadora-de-maquina.model'
import { Empresa } from '../../pkw-data/core/empresa.model'
import { FiltroEstabelecimento } from '../shared/filtro-estabelecimento'

@Component({
    selector: 'col-filtro-estabelecimentos-form',
    templateUrl: './filtro-estabelecimentos-form.component.html'
})
export class FiltroEstabelecimentosFormComponent {
    @Input() empresas: Empresa[]
    @Input() operadoras: OperadoraDeMaquina[]

    @Output() submit: EventEmitter<FiltroEstabelecimento>

    @ViewChild(NgForm) form: NgForm

    situacoes: Situacao[]
    submitted: boolean
    model: FiltroEstabelecimento

    constructor() {
        this.empresas = []
        this.operadoras = []
        this.situacoes = [
            Situacao.Ativo,
            Situacao.Inativo,
            Situacao.OperadoraForaDoAr,
            Situacao.VerificarSenha,
            Situacao.ExigirAcaoUsuario,
            Situacao.BloqueioDuplaAutenticacao
            /**
             * TODO: Remover após estabilizar o novo collect na produção, permanecer até não existirem
             * estabelecimentos sincronizando na produção
             // Situacao.Sincronizando
             */
        ]
        this.submitted = false
        this.submit = new EventEmitter<FiltroEstabelecimento>()
        this.model = new FiltroEstabelecimento()
    }

    onNgFormSubmit($event: Event) {
        $event.stopPropagation()

        this.submitted = true
        this.model = new FiltroEstabelecimento()
        this.model.pesquisa = this.form.value.pesquisa
        this.model.empresa = this.form.value.empresa
        this.model.operadora = this.form.value.operadora
        this.model.situacao = this.form.value.situacao as Situacao

        this.submit.emit(this.model)
    }

    limpar() {
        this.submitted = false
        this.model = new FiltroEstabelecimento()
        this.form.resetForm({
            pesquisa: '',
            empresa: null,
            operadora: null,
            situacao: null
        })
    }
}



// WEBPACK FOOTER //
// ./src/app/estabelecimentos/filtro-estabelecimentos-form/filtro-estabelecimentos-form.component.ts